import { render } from "./TheControlSidebar.vue?vue&type=template&id=50e8003d"
import script from "./TheControlSidebar.vue?vue&type=script&lang=js"
export * from "./TheControlSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__